import { bindActionCreators } from 'redux';
import { connect, Dispatch } from 'react-redux';
import * as React from 'react';

import UploadButton, { Props as UploadButtonProps } from 'components/UploadButton';
import { UploadRequestData } from 'reducers/fileUploads';
import { loadThumbnail, uploadRequest } from 'reducers/fileUploads';
import { OrderedMap } from 'immutable';

/**
 * ## Wraps UploadButton with
 * ### State managed in redux reducers/fileUploads.js
 *
 * ```example
 * <ReduxUploadButton>
 *  Click here to upload file
 * </ReduxUploadButton>
 * ```
 */

type FileUploadsFromReduxState = OrderedMap<string, UploadRequestData>;
type ReduxStateProps = { fileUploads: FileUploadsFromReduxState };
export type ReduxDispatchProps = {
  uploadRequest: typeof uploadRequest;
  loadThumbnail?: typeof loadThumbnail;
};

export class ReduxUploadButton extends React.Component<
  UploadButtonProps & ReduxStateProps & ReduxDispatchProps
> {
  render() {
    const { children, fileContextKey, fileUploads, privateUpload, ...rest } = this.props;
    return (
      <UploadButton
        fileContextKey={fileContextKey}
        uploadRequest={this.props.uploadRequest}
        disabled={!fileUploads.isEmpty()}
        privateUpload={privateUpload}
        {...rest}>
        {children}
      </UploadButton>
    );
  }
}

const mapStateToProps = (
  state: { fileUploads: FileUploadsFromReduxState },
  props: UploadButtonProps
): ReduxStateProps => {
  const { fileUploads } = state;
  const fileGroup = fileUploads.get(props.fileContextKey);
  return {
    fileUploads: fileGroup
      ? OrderedMap<string, UploadRequestData>({ [props.fileContextKey]: fileGroup })
      : OrderedMap<string, UploadRequestData>(),
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>): ReduxDispatchProps =>
  bindActionCreators(
    {
      uploadRequest,
      loadThumbnail,
    },
    dispatch
  );

export default connect<ReduxStateProps, ReduxDispatchProps, UploadButtonProps>(
  mapStateToProps,
  mapDispatchToProps
)(ReduxUploadButton);
